import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject, _templateObject2, _templateObject3;
var getThumbStyles = function getThumbStyles(_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$theme = _ref.theme,
    borderRadius = _ref$theme.borderRadius,
    colours = _ref$theme.colours,
    effects = _ref$theme.effects,
    sizing = _ref$theme.sizing;
  return {
    appearance: 'none',
    background: colours["interface"].main,
    border: "".concat(sizing.xtiny, " solid ").concat(colours.canvas.tertiary.main),
    borderRadius: borderRadius.ellipse,
    cursor: disabled ? undefined : 'grab',
    height: sizing.medium,
    width: sizing.medium,
    '&:hover': {
      background: colours["interface"].strong,
      boxShadow: effects.dropShadow.regular
    },
    '&:active': {
      background: colours["interface"].strong,
      boxShadow: effects.dropShadow.uber,
      cursor: disabled ? undefined : 'grabbing'
    }
  };
};
var Slider = styled.input.attrs(function () {
  return {
    type: 'range'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  appearance: none;\n  background: transparent;\n  cursor: ", ";\n  position: absolute;\n  top: -", ";\n  width: 100%;\n\n  &[data-active='true'] {\n    z-index: 1;\n  }\n\n  &::-webkit-slider-thumb {\n    ", "\n  }\n\n  &::-moz-range-thumb {\n    ", ";\n    box-sizing: border-box;\n    transform: ", ";\n  }\n\n  &:focus-visible {\n    &::-webkit-slider-thumb {\n      background: ", ";\n      box-shadow: ", ";\n    }\n    &::-moz-range-thumb {\n      background: ", ";\n      box-shadow: ", ";\n    }\n    outline: none;\n  }\n"])), function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? undefined : 'pointer';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.sizing.tiny;
}, getThumbStyles, getThumbStyles, function (_ref4) {
  var theme = _ref4.theme;
  return "translateY(-".concat(theme.sizing.xtiny, ")");
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colours["interface"].strong;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.effects.dropShadow.uber;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colours["interface"].strong;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.effects.dropShadow.uber;
});
var Root = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", ";\n  opacity: ", ";\n  position: relative;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.sizing.small;
}, function (_ref10) {
  var $disabled = _ref10.$disabled,
    theme = _ref10.theme;
  return $disabled && theme.opacity.disabled;
});
var SliderOrientation = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref11) {
  var $isReversed = _ref11.$isReversed;
  return $isReversed && 'transform: rotate(-180deg)';
});

export { Root, Slider, SliderOrientation };
//# sourceMappingURL=Slider.styles.js.map
